export default "__VITE_PUBLIC_ASSET__218f4bae__"